module.exports = __webpack_public_path__ + "img/clip.2391ba96.svg";